<script setup lang="ts">
  import { computed, onMounted, ref } from 'vue'
  import { FlowPersonalInformationWidget } from '@/widgets/Flow'
  import { useCommonStore } from '@/shared/store'
  import { useApiRequestsAbort, usePerformanceTiming } from '@/shared/composables'
  import { TravelDirection } from '@/shared/types/common.types'
  import { useFormDataWithRedirect } from '@/shared/composables/useFormDataWithRedirect'

  interface Emits {
    (e: 'load', request: () => Promise<any>, requestId?: string): void
  }
  const emit = defineEmits<Emits>()

  useApiRequestsAbort()

  const { getFormData } = useFormDataWithRedirect()
  const commonStore = useCommonStore()
  const { onPerformanceCheckEnd } = usePerformanceTiming()

  const loadingFormData = ref(true)

  const nationalities = computed(() => commonStore.nationalities)

  const fetchNationalities = async () => {
    if (nationalities.value.length > 0) return

    const data = await commonStore.findNationalities()
    commonStore.setNationalities(data)
  }

  onMounted(() => {
    emit(
      'load',
      async () => {
        if (!(await getFormData(TravelDirection.INBOUND, true, true))) return
        loadingFormData.value = false
        await fetchNationalities()
        onPerformanceCheckEnd()
      },
      'getNationalities'
    )
  })
</script>

<template>
  <FlowPersonalInformationWidget
    :with-winter-sport="false"
    :type-of-travel="TravelDirection.INBOUND"
    :loading-form-data="loadingFormData"
    @load="emit('load', $event)"
  />
</template>
